/**
 * Labstep
 *
 * @module components/Folder/Action/Create
 * @desc Create Action for folder
 */

import { CanCreate } from 'labstep-web/components/Entity/Can';
import { FolderFormCreate } from 'labstep-web/components/Folder/Form/Create';
import { ParamsContext } from 'labstep-web/contexts/params';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { ParamsHOC } from 'labstep-web/hoc/Params';
import { Folder } from 'labstep-web/models/folder.model';
import { enhanceOptions } from 'labstep-web/services/utils.service';
import type React from 'react';
import type { FolderActionCreateProps } from './types';

export const FolderActionCreate: React.FC<
  FolderActionCreateProps
> = ({ folderType, options, actionComponentProps }) => (
  <CanCreate entityName={`folder_${folderType}`}>
    <ModalDefault
      header={`Create new ${Folder.getHumanReadableEntityName()}`}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          onClick={toggleModal}
          icon="plus"
          text={`New ${Folder.getHumanReadableEntityName(
            false,
            true,
          )}`}
          type="text"
          {...actionComponentProps}
        />
      )}
      content={({ toggleModal }) => (
        <FolderFormCreate
          type={folderType}
          options={enhanceOptions({
            options,
            onSuccess: toggleModal,
          })}
        />
      )}
    />
  </CanCreate>
);

export const FolderActionCreateContainer: React.FC<
  FolderActionCreateProps
> = (props) => (
  <ParamsHOC historyAction="replace">
    <ParamsContext.Consumer>
      {({ setParams }) => (
        <FolderActionCreate
          {...props}
          options={{
            onSuccess: ({ response }) =>
              setParams({ folder_id: response!.result }),
          }}
        />
      )}
    </ParamsContext.Consumer>
  </ParamsHOC>
);
